// Accordion

(function($, Drupal) {

  'use strict';

  Drupal.behaviors.accordion = {
    attach(context) {
      $('.accordion:not(.accordion-with-image-item) .accordion-item-inner .ac-title').off('click').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation(); // Stop event propagation to prevent multiple event triggers
  
        const $this = $(this);
        const $accordionItemInner = $this.closest('.accordion-item-inner');
  
        if ($accordionItemInner.hasClass('opened')) {
          $accordionItemInner.removeClass('opened').addClass('closed');
          $this.find('.ac-accessibilty-txt').text('click to close accordion');
        } else {
          $('.accordion-item-inner.opened').not($accordionItemInner).removeClass('opened').addClass('closed');
          $accordionItemInner.toggleClass('opened').find('.ac-accessibilty-txt').text('click to open accordion');
        }
      });
    }
  };

})(jQuery, Drupal);
